<div id="div-table-1" class="container-filter-cards">
  <div id="div-table-2" class="container-breadcrumb">
    <p id="id-breadcrumb-3" class="copec-lg-14 bread-3">Admin / Perfiles /</p>
  </div>
  <div id="div-table-3" class="container-button-subtitle">
    <div  id="div-table-4" class="box-button1"><span class="copec-bold-30">Perfiles</span></div>
    <div  id="div-table-5" class="box-button2">
      <button id="but-prof-1" class="button-profiles" (click)="openDialog()">
        Añadir nuevo perfil
      </button>
    </div>
  </div>
  <div  id="div-table-6" class="container-search-order">
    <div class="search-bar">
      <i id="id-i" class="fa-solid fa-magnifying-glass"></i>
      <input id="but-prof-2"
      (input) ="searchFilter()"
      [(ngModel)]="searchTerm"
        maxlength="70"
        type="text"
        placeholder="Buscar"
        #input
      />
    </div>
    <div  id="div-table-7">
      <select id="ben-select-1">
        <option id="but-prof-3" value="order">Ordenar por</option>
        <option id="but-prof-4" value="mostOld">De antiguo a reciente</option>
        <option id="but-prof-5" value="actually">De reciente a antiguos</option>
        <option id="but-prof-6" value="ordertoA">A-Z</option>
        <option id="but-prof-7" value="ordertoZ">Z-A</option>
      </select>
    </div>
  </div>

  <div  id="div-table-8">
    <table id="but-tbl-prof-1"
      mat-table
      [dataSource]="dataSource"
      matSort
      (matSortChange)="announceSortChange($event)"
      class="table-responsive mat-elevation-z8"
      aria-label="Tabla de Perfiles"
    >
      <ng-container matColumnDef="id">
        <th id="prof-th-id-1"
          class="th-header"
          mat-header-cell
          *matHeaderCellDef
          class="display-none"
        >
          ID
        </th>
        <td id="prof-td-id-1" mat-cell *matCellDef="let element" class="display-none">
          {{ element.id }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name" removeRowDef>
        <th id="prof-th-id-2"
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          sortActionDescription="Sort by name"
          class="display-none"
        >
          Nombre
        </th>
        <td id="prof-th-id-3"
          mat-cell
          *matCellDef="let element"
          remove
          class="display-none"
          RowDef
        >
          {{ element.name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th id="prof-th-id-4" mat-header-cell *matHeaderCellDef class="display-none">Email</th>
        <td id="prof-td-id-4" mat-cell *matCellDef="let element" class="display-none">
          {{ element.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="rut">
        <th id="prof-th-id-5" mat-header-cell *matHeaderCellDef class="display-none">RUT</th>
        <td id="prof-td-id-5" mat-cell *matCellDef="let element" class="display-none">
          {{ element.rut }}
        </td>
      </ng-container>

      <ng-container matColumnDef="typeUser">
        <th id="prof-th-id-6" mat-header-cell *matHeaderCellDef class="display-none">
          Tipo de usuario
        </th>
        <td id="prof-td-id-6" mat-cell *matCellDef="let element" class="display-none">
          {{ element.typeUser }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th id="prof-th-id-7" mat-header-cell *matHeaderCellDef class="display-none">Estado</th>
        <td id="prof-td-id-7" mat-cell *matCellDef="let element" class="display-none">
          <mat-chip
            mat-chip
            [ngClass]="{
              'chip-activo': element.status.toLowerCase() === 'activo',
              'chip-inactivo': element.status.toLowerCase() === 'inactivo'
            }"
            [disabled]="
              element.status.toLowerCase() === 'activo' ? false : true
            "
          >
            <span
              [ngClass]="{
                'clip-text-activo': element.status.toLowerCase() === 'activo',
                'clip-text-inactivo':
                  element.status.toLowerCase() === 'inactivo'
              }"
            >
              {{ element.status }}
            </span>
          </mat-chip>
        </td>
      </ng-container>

      <ng-container matColumnDef="status2">
        <th id="prof-th-id-8" mat-header-cell *matHeaderCellDef class="display-estado">Estado</th>
        <td id="prof-td-id-8" mat-cell *matCellDef="let element" class="display-estado">
          <div id="div01-019">
            {{ element.email }} <br />
            <mat-chip
              mat-chip
              [disabled]="
                element.status.toLowerCase() === 'activo' ? false : true
              "
              ><span id="span-01"
                [ngClass]="{
                  'clip-text-activo': element.status.toLowerCase() === 'activo',
                  'clip-text-inactivo':
                    element.status.toLowerCase() === 'inactivo'
                }"
              >
                {{ element.status }}
              </span>
            </mat-chip>
          </div>
        </td>
      </ng-container>

      <tr id="prof-td-id-9" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr id="prof-td-id-10" mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr id="prof-td-id-11" class="mat-row" *matNoDataRow>
        <td id="prof-td-id-12"class="mat-cell" colspan="6">
          No se encontraron resultados para "{{ input.value }}"
        </td>
      </tr>
    </table>
  </div>

  <div  id="div-table-9">
    <app-paginator 
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      (pageChange)="onPageChange($event)"
    ></app-paginator>
  </div>
</div>
